import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import type { VersioningActions } from "./types";
import type { ChangeEvent } from "react";
import { SaveVersionAction } from "./VersionAction/SaveVersionAction";
import { ChangeNameVersionAction } from "./VersionAction/ChangeNameVersionAction";
import { AddVersionButton } from "./VersionAction/AddVersionButton";
import { RestoreVersionAction } from "./VersionAction/RestoreVersionAction";
import { DeleteVersionAction } from "./VersionAction/DeleteVersionAction";
import styles from "./styles.module.css";
import {
  StorageObjectValue,
  StorageScope,
} from "../../services/api/instances/storageApi/types/service_types";
import { StorageObjectVersion } from "../../services/api/instances/storageApi/types/object_types";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import classNames from "classnames";

interface Props {
  versions: StorageObjectVersion<StorageObjectValue>[];
  selectedVersion: StorageObjectVersion<StorageObjectValue> | null;
  onOpenSaveVersionModal: (type: VersioningActions) => void;
  onOpenRestoreVersionModal: (type: VersioningActions) => void;
  onEditName: (name: string) => void;
  onRefreshVersion: () => void;
  onDeleteVersion: () => void;
  isSaveButtonDisabled: boolean;
  service: StorageScope;
}

export const VersioningServiceManager = (props: Props) => {
  const [versionName, setVersionName] = useState<string>(
    props.selectedVersion?.version_name!,
  );
  const { selectedObject } = useStorageSelectors(props?.service);
  const { t } = useTranslation();

  useEffect(() => {
    setVersionName(props.selectedVersion?.version_name!);
  }, [props.selectedVersion?.version_name]);

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setVersionName(event.target.value);
  };

  return (
    <div className={styles.container}>
      <div className={styles["version-label"]}>
        {t("versioning.active_version")}
      </div>
      <div
        className={classNames(
          styles["actions-wrapper"],
          !selectedObject?.owner && styles["disabled-block"],
        )}
      >
        <RestoreVersionAction
          name={props?.selectedVersion?.version_name as string}
          onClick={() => props.onOpenRestoreVersionModal("restore")}
        />
        <AddVersionButton
          onClick={() => props.onOpenSaveVersionModal("save")}
        />
        <SaveVersionAction
          name={props.selectedVersion?.version_name!}
          onRefreshVersion={props.onRefreshVersion}
          isDisabled={
            props.selectedVersion?.version_name === undefined ||
            props.isSaveButtonDisabled
          }
        />
        <ChangeNameVersionAction
          name={versionName}
          handleNameChange={handleNameChange}
          onEditName={() => props.onEditName(versionName)}
          isDisabled={props.versions?.length === 0}
          onCancel={() =>
            setVersionName(props.selectedVersion?.version_name as string)
          }
        />
        <DeleteVersionAction
          name={props.selectedVersion?.version_name as string}
          onDelete={props.onDeleteVersion}
        />
      </div>
    </div>
  );
};
